import debtpaymentService from '../../services/debtpayment-service';

const state = () => ({

    loading: false,
    debtpayments: [],
    selectedDebt: {},
    error: null
})

const actions = {
    getAll({ commit }) {
        commit('Loading', true);
        commit('Failure', null)
        debtpaymentService.getAll()
            .then(
                response => {
                    //console.log(debtpayments);
                    commit('Success', response.data);
                    commit('Loading', false)
                    
                },
                error => {
                    commit('Failure', error)
                    commit('Loading', false)
                }
            );
    },
    add({ commit, state }, data) {
        commit('Failure', null)
        commit('Loading', true)
        debtpaymentService.create(data)
            .then(
                response => {
                    if (response.status == 200) {

                        data.id = response.data.id;
                        data.created_at = response.data.created_at;
                        commit('AddSel', data)
                        commit('Loading', false)
                       
                    }
                },
                error => {
                    commit('Failure', error)
                    commit('Loading', false)
                }
            )

    },
    delete({ commit, state }, data) {
        commit('Loading', true)
        commit('Failure', null)
        debtpaymentService.delete(data.debtpayment.id)
            .then(
                response => {
                    //state.debtpayments.splice(data.index, 1)
                    commit('RemoveSel', data.debtpayment)
                    commit('Loading', false)
                },
                error => {
                    commit('Failure', error)
                    commit('Loading', false)
                }
            )
    },

    selectedDebt({ commit }, data) {
        commit('SelectedDebt', data)
    }

}


const mutations = {
    Loading(state, status) {
        state.loading = status;
    },
    Success(state, debtpayments) {
        state.debtpayments = debtpayments;
    },
    SelectedDebt(state, payload) {
        state.selectedDebt = payload;
    },
    Failure(state, error) {
        state.error = error;
    },
    Deleted_debtpayment(state, payload) {
        //to be implemented for undo feature later
    },
    Remove(state, index) {
        state.debtpayments.splice(index, 1)
    },
    Add(state, payload) {
        state.debtpayments.unshift(payload);
    },
    RemoveSel(state, debtpayment) {
        var dp_index = state.selectedDebt.debtpayments.indexOf(debtpayment);
        state.selectedDebt.debtpayments.splice(dp_index, 1)
    },
    AddSel(state, payload) {
        state.selectedDebt.debtpayments.unshift(payload);
    }

}

const getters = {
    DEBTPAYMENTS: state => {
        return state.debtpayments
    },
    SELECTEDDEBTPAYMENTS: state => {
        return state.selectedDebt.debtpayments
    },

    DEBTPAYMENT_ERROR: state => {
        return state.error
    },
    DEBTPAYMENTS_LOADING: state => {
        return state.loading
    },


}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}